module.exports = __webpack_public_path__ + "static/media/2b_website_logo_adv_ctech.d64b35ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/2b_website_logo_adv_ctech.jpg
// module id = 40
// module chunks = 0